module.exports = __webpack_public_path__ + "static/media/save-json.a7f36dd4.gif";


//////////////////
// WEBPACK FOOTER
// ./src/res/img/help/save-json.gif
// module id = 430
// module chunks = 0